

// JS version of props from the Vuetify-Pro ActionMenuButton
// Mirrors the TS API but without generics/types.

import { actionButtonProps, extActionButtonProps } from '@/tiptap/extensions/components/ActionButton'
import { omit } from '@/tiptap/utils/utils'

// Public props for the concrete ActionMenuButton component
export const actionButtonMenuProps = {
  // inherit ActionButton props but drop callback-specific ones
  ...omit(actionButtonProps, ['action', 'isActive']),

  maxHeight: {
    type: [String, Number],
    default: undefined,
  },

  // Menu items: array of { title, icon?, action, isActive, disabled?, divider?, default?, style? }
  items: {
    type: Array,
    default: () => [],
  },
}

// Props helper for the extension-driven *menu* buttons (Heading, TextAlign, etc.)
// Usage in SFCs:  const props = defineProps(extActionButtonMenuProps())
export const extActionButtonMenuProps = () => ({
  ...extActionButtonProps,
  // the extension instance whose options feed the menu (e.g., levels, alignments)
  extension: {
    type: Object,
    required: true,
  },
})